import React from "react"
import Helmet from "react-helmet"
import Link from "gatsby-link"

export default ({ data }) => {
  return (
    <div>
      <Helmet 
        title="The musings of a freelance web developer"
        meta={[
          {
            name: 'description', content: 'Code Barn, latest in technology, trends and gossip',
          },
        ]} 
        bodyAttributes={{class: '__static' }} />
      <div className="wrapper white">
        <div className="section columnar story">
          <header>
            <h1>Blog</h1>
            <p>Latest in technology, trends and gossip</p>
          </header>
          {data.allMarkdownRemark.edges.map(({node}, index) => (
            <article key={index}>
              <h2>
                {node.frontmatter.title}
              </h2>
              <p>
                {node.excerpt}
              </p>
              <p>
                <Link to={node.fields.slug}>Read more</Link>
              </p>
            </article>                
          ))}                   
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query codeBarnPages {
    allMarkdownRemark(
      filter: { 
        frontmatter: { layout: { eq: "Blog" } } 
      }
      sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          frontmatter {
            title
          }
          fields {
            slug
          }
          excerpt(pruneLength: 500)
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/blog.js